<template>
  <div class="noWrap">
    {{ getType }}
  </div>
</template>

<script>
import ProductType from 'Arch/enums/TypeOperation';

export default {
  name: 'ProductTypeOperationColumn',
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    types: ProductType,
  }),
  computed: {
    getType() {
      return this.findType || this.value;
    },
    findType() {
      return this.types.find((type) => type.value === this.value).text;
    },
  },
};
</script>
